import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import CallSharingDialog from 'components/pure/sharing/CallSharingDialog';
import SkillStore from 'stores/SkillStore';
import SkillActions from 'actions/SkillActions';
import AccountStore from 'stores/AccountStore';
import SharingActions from 'actions/sharing/SharingActions';
import SharingFormActions from 'actions/sharing/SharingFormActions';
import AuthStore from 'stores/AuthStore';
import AccountActions from 'actions/AccountActions';
import anyTargetMayHaveSlack from 'stores/sharing/anyTargetMayHaveSlack';
import {ensureReviewMetadata} from 'components/StatsPage2.utils';
import FileUploadStore from 'stores/files/FileUploadStore';
import SearchStore from 'stores/SearchStore';
import CallCardActions from '@store/call-card/CallCardActions';
import FileUploadSharingDialogFormStore from 'stores/sharing/FileUploadSharingDialogFormStore';
import UserStore from 'stores/UserStore';
import FileUploadSharingStore from 'stores/sharing/FileUploadSharingStore';
import FileUploadActions from 'actions/files/FileUploadActions';

class CallSharingDialogContainer extends React.Component {
  static getStores() {
    return [
      AccountStore,
      AuthStore,
      SkillStore,
      FileUploadStore,
      SearchStore,
      FileUploadSharingStore,
      FileUploadSharingDialogFormStore,
      UserStore,
    ];
  }

  static getPropsFromStores(props) {
    const {user: authUser} = AuthStore.getState();
    const {skillsByTeamList} = SkillStore.getState();
    const {hasSlack, hasSlackLoaded} = AccountStore.getState();

    const sharingValues = FileUploadSharingDialogFormStore.getState().get('sharingValues');
    const {users} = UserStore.getState();
    const targetsMightHaveSlack = anyTargetMayHaveSlack(sharingValues, users);
    const fileUpload =
      props.fileUpload ??
      FileUploadStore.getState().fileUploadsMap.get(props.fileUploadId) ??
      SearchStore.getState().searchResults.results.find(call => call.id === props.fileUploadId);

    return {
      fileUpload,
      authUser,
      open,
      skills: skillsByTeamList,
      hasSlack,
      hasSlackLoaded,
      targetsMightHaveSlack,
    };
  }

  componentDidMount() {
    const {authUser, fileUpload, fileUploadId} = this.props;

    if (!fileUpload) {
      FileUploadActions.findFilesById([fileUploadId]);
    }

    AccountActions.hasSlack.defer();

    // find any open plans where we are the coach or recipient.
    CoachingPlanActions.fetchAll.defer({
      coachId: authUser.id,
      recipientId: authUser.id,
      includeCompleted: false,
      includeReviews: true,
    });

    SkillActions.fetchAllByTeam.defer({
      team_id: this.props.caller.teamId,
    });

    setTimeout(() => {
      ensureReviewMetadata();
    }, 0);
  }

  componentWillUnmount() {
    if (this.props.fileUploadId) {
      CallCardActions.getUserCallActivity.defer(this.props.fileUploadId);
    }
  }

  render() {
    return <CallSharingDialog {...this.props} onClose={onClose} />;
  }
}

function onClose() {
  SharingActions.closeSharingDialog();
  SharingFormActions.reset();
}

export default connectToStores(CallSharingDialogContainer);
